import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr, zl } from "@/lib/api";

const EMPTY = { code: "", kind: "percent", value: 10, valid_until: "", max_uses: 0, active: true };
const today = () => new Date().toISOString().slice(0, 10);
const worth = (d) => (d.kind === "percent" ? `−${d.value}%` : `−${zl(d.value)}`);

const status = (d) => {
  if (!d.active) return "wyłączony";
  if (d.valid_until && d.valid_until < today()) return "wygasł";
  if (d.max_uses && d.uses >= d.max_uses) return "wyczerpany";
  return "aktywny";
};

const Form = ({ onCreate }) => {
  const [v, setV] = useState(EMPTY);
  const set = (k, num) => (e) => setV({ ...v, [k]: num ? Number(e.target.value) : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (await onCreate(v)) setV(EMPTY);
  };
  return (
    <form className="inq disc-form" onSubmit={submit} data-testid="discount-form">
      <div className="fe-field"><label>Kod</label><input value={v.code} onChange={(e) => setV({ ...v, code: e.target.value.toUpperCase().replace(/\s/g, "") })} placeholder="ROCZNICA10" data-testid="discount-code-input" /></div>
      <div className="fe-field"><label>Rodzaj</label>
        <select value={v.kind} onChange={set("kind")} data-testid="discount-kind-select"><option value="percent">Procent (%)</option><option value="amount">Kwota (zł)</option></select></div>
      <div className="fe-field"><label>{v.kind === "percent" ? "Rabat (%)" : "Rabat (zł)"}</label><input type="number" min="1" max={v.kind === "percent" ? 100 : undefined} value={v.value} onChange={set("value", true)} data-testid="discount-value-input" /></div>
      <div className="fe-field"><label>Ważny do (puste = bez końca)</label><input type="date" value={v.valid_until} onChange={set("valid_until")} data-testid="discount-valid-input" /></div>
      <div className="fe-field"><label>Limit użyć (0 = bez limitu)</label><input type="number" min="0" value={v.max_uses} onChange={set("max_uses", true)} data-testid="discount-limit-input" /></div>
      <button className="btn solid" type="submit" data-testid="discount-create-btn">Dodaj kod</button>
    </form>
  );
};

const Row = ({ d, onUpdate, onDelete }) => (
  <article className="inq" data-testid={`discount-card-${d.code}`}>
    <div className="inq-head">
      <h3>{d.code} · <em style={{ color: "var(--gold)" }}>{worth(d)}</em></h3>
      <span className="label" data-testid={`discount-status-${d.code}`}>{status(d)}</span>
    </div>
    <div className="inq-meta">
      <div><span>Użycia</span><b data-testid={`discount-uses-${d.code}`}>{d.uses}</b>{d.max_uses ? ` / ${d.max_uses}` : " (bez limitu)"}</div>
      <div><span>Ważny do</span>{d.valid_until ? new Date(d.valid_until + "T12:00").toLocaleDateString("pl-PL") : "bez końca"}</div>
    </div>
    <div className="inq-tools">
      <label className="check"><input type="checkbox" checked={d.active} onChange={(e) => onUpdate(d, { active: e.target.checked })} data-testid={`discount-active-${d.code}`} />Aktywny</label>
      <button className="mini danger" onClick={() => window.confirm(`Usunąć kod ${d.code}?`) && onDelete(d.id)} data-testid={`discount-delete-${d.code}`}>Usuń</button>
    </div>
  </article>
);

export const Discounts = () => {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/discounts").then(({ data }) => setList(data)).catch((e) => toast.error(formatErr(e))); }, []);

  const create = async (v) => {
    try { const { data } = await api.post("/discounts", v); setList((l) => [data, ...l]); toast.success(`Dodano kod ${data.code}`); return true; }
    catch (e) { toast.error(formatErr(e)); return false; }
  };
  const update = async (d, patch) => {
    const { code, kind, value, valid_until, max_uses, active } = { ...d, ...patch };
    try { const { data } = await api.put(`/discounts/${d.id}`, { code, kind, value, valid_until, max_uses, active }); setList((l) => l.map((x) => (x.id === d.id ? data : x))); toast.success("Zapisano"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const del = async (id) => {
    try { await api.delete(`/discounts/${id}`); setList((l) => l.filter((x) => x.id !== id)); toast.success("Usunięto"); }
    catch (e) { toast.error(formatErr(e)); }
  };

  if (!list) return <p className="adm-sub">Ładowanie…</p>;
  return (
    <div data-testid="admin-discounts">
      <h1>Kody rabatowe</h1>
      <p className="adm-sub">Klient wpisuje kod w formularzu rezerwacji, a orientacyjna cena przelicza się od razu. Użycie kodu liczy się po wysłaniu zapytania.</p>
      <div className="inq-list" style={{ marginTop: 28 }}>
        <Form onCreate={create} />
        {list.length ? list.map((d) => <Row key={d.id} d={d} onUpdate={update} onDelete={del} />) : <p className="adm-sub" data-testid="discounts-empty">Nie masz jeszcze żadnych kodów.</p>}
      </div>
    </div>
  );
};
